import React, { useEffect, useState } from 'react';
import { UploadPhotoForm } from '@organisms/index';
import { NavigationButtonProps, NavigationButtons } from '@molecules/index';
import { ErrorMessages } from '@types';
import { ErrorSummary } from '@atoms/index';

export interface UploadPhotoTemplateProps {
  id?: string;
  formTitle?: string;
  description?: string | React.ReactNode;
  errorPath?: string;
  errorMessages?: ErrorMessages[];
  handleFileChange: (files: File[]) => void | Promise<void>;
  handleUploadError: (error: string) => void;
  handleDelete?: (files: File[]) => void | Promise<void>;
  maxNumberOfUpload?: number;
  initialFiles?: File[];
  buttonNext: NavigationButtonProps;
  buttonPrevious: NavigationButtonProps;
  dropzoneLabel?: string;
  acceptedFileTypes?: string[];
}

export const UploadPhotoTemplate: React.FC<UploadPhotoTemplateProps> = ({
  formTitle,
  description,
  handleFileChange,
  handleUploadError,
  handleDelete,
  maxNumberOfUpload = 1,
  buttonNext,
  buttonPrevious,
  errorPath,
  errorMessages,
  initialFiles,
  dropzoneLabel,
  acceptedFileTypes,
}) => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>(
    initialFiles || [],
  );

  useEffect(() => {
    if (initialFiles) {
      setUploadedFiles(initialFiles);
    }
  }, [initialFiles]);

  const handleAddFile = async (files: File[]) => {
    if (handleFileChange) {
      await handleFileChange(files);
    }
    setUploadedFiles(files);
  };

  const handleDeleteFile = async (files: File[]) => {
    if (handleDelete) {
      await handleDelete(files);
    }
    setUploadedFiles(files);
  };

  const buttonLabel =
    uploadedFiles && uploadedFiles.length > 0 ? 'Next' : buttonNext.label;

  return (
    <div>
      <ErrorSummary messages={errorMessages} />
      <UploadPhotoForm
        // set to errorPath so that click on error message can navigate to the correct field
        id={errorPath}
        formTitle={formTitle}
        description={description}
        handleFileChange={handleAddFile}
        handleUploadError={handleUploadError}
        handleDelete={handleDeleteFile}
        maxNumberOfUpload={maxNumberOfUpload}
        errorPath={errorPath}
        errorMessages={errorMessages}
        initialFiles={uploadedFiles}
        dropzoneLabel={dropzoneLabel}
        acceptedFileTypes={acceptedFileTypes}
      />
      <NavigationButtons
        buttonNext={{
          ...buttonNext,
          label: buttonLabel,
        }}
        buttonPrevious={buttonPrevious}
      />
    </div>
  );
};
